module.exports = __webpack_public_path__ + "static/img/gxg_05.d8aa532.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gxg_img/gxg_05.png
// module id = S98N
// module chunks = 46